import styled from "styled-components";
import media from "styled-media-query";

import sun from "../../images/sun.png";
import moon from "../../images/moon.png";

export const Wrapper = styled.label`
  display: inline-block;
  width: 70px;
  height: 25px;
  z-index: 1;
  right: 3.25rem;
  position: absolute;
  top: 3.75rem;

  ${media.lessThan("large")`
      top: 5rem;
      right: .50rem;
  `}
`;

export const InputCheckBox = styled.input`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + .slider {
    background-color: #fc7303;
  }

  &:focus + .slider {
    box-shadow: 0 0 1px #fc7303;
  }

  &:checked + .slider:before {
    -webkit-transform: translateX(35px);
    -ms-transform: translateX(35px);
    transform: translateX(35px);
    background: white;
    background-size: 20px !important;
    background-image: url(${sun});
    background-repeat: no-repeat;
    background-position: center;
  }
`;

export const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: darkslategray;
  -webkit-transition: 0.4s;
  transition: 0.4s;

  &:before {
    position: absolute;
    content: "";
    height: 35px;
    width: 35px;
    left: 0px;
    bottom: 4px;
    top: 0;
    bottom: 0;
    margin: auto 0;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    box-shadow: 0 0px 15px #2020203d;
    background-size: 20px !important;
    background: white url(${moon});
    background-repeat: no-repeat;
    background-position: center;
  }

  ${props =>
    props.round &&
    `
        border-radius: 34px;

        &:before {
            border-radius: 50%;
        }
  
  `}
`;
